import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const TextEditor = ({...rest}) => {
  return (
    <CKEditor
      editor={ClassicEditor}
      data={rest.value || ""}
      config={{
        ...rest.config,
      }}
      onReady={editor => {
        editor.ui.view.editable.element.style.minHeight = "140px";
      }}
      style={{ minHeight: 300 }}
      {...rest}
    />
  );
};

export default TextEditor;
